import { useEffect } from 'react';
import { GiftList } from '../../components/gifts/gift-list';
import { Seo } from '../../components/seo';
import { useUIStore } from '../../store/ui-store';

function GiftsListPage() {
  const { setTitle, setBreadcrumbs } = useUIStore();

  useEffect(() => {
    setBreadcrumbs([]);
    setTitle('Manage Gifts');
  }, [setBreadcrumbs, setTitle]);

  return (
    <>
      <Seo title="Manage Gifts" />
      <div className="px-12 pt-10 pb-[35px]">
        <GiftList />
      </div>
    </>
  );
}

export default GiftsListPage;
